import type { DirectiveBinding } from 'vue'
import { commonStore } from '@/stores/common'
// v-authorize="53"   v-authorize v-authorize=["53"]满足其中一个

// type Permission = {
//   id: string
//   resourceId: string
//   resourceName: string
//   resourceUrl: string
//   parentResourceId: string
//   children?: Permission[]
// }

export default function (el: HTMLElement, binding: DirectiveBinding) {
  let hasPermission = false
  const store = commonStore()
  const permission = store.resourceIdList || []
  let value = binding.value
  if (value) {
    value = Array.isArray(value) ? value : [value]
    hasPermission = permission.some(item => value.includes(+item.resourceId))
  } else {
    let innerText = el.innerText
    const children = el.children
    if (!innerText) innerText = (children[0] as HTMLElement).innerText
    hasPermission = permission.some(item => item.resourceName === innerText.trim())
  }
  el.style.display = hasPermission ? '' : 'none'
}
